import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { UTCalendarModule } from '@ruby/modules/unit-train/submodules/ut-calendar/ut-calendar.module';
import { DialogFooterModule } from '@ruby/shared/dialogs/dialog-footer/dialog-footer.module';
import { DialogHeaderModule } from '@ruby/shared/dialogs/dialog-header/dialog-header.module';
import { LocationCalendarDialog } from '@ruby/shared/dialogs/unit-train/location-calendar/components/location-calendar.dialog';

@NgModule({
  declarations: [LocationCalendarDialog],
  imports: [
    CommonModule,
    DialogHeaderModule,
    DialogFooterModule,
    MatButtonModule,
    MatDialogModule,
    UTCalendarModule
  ],
  exports: [LocationCalendarDialog]
})
export class LocationCalendarModule {}
